import React from 'react';
import { Auto } from 'fw/forms';
import * as API from 'modules/app/API'

class SponsorAuto extends React.Component {

	sponsorsLoader = () => {
		return {
			url: API.App.url('/lookup/lookupSponsor'),
			params: {
				value: this.props.value
			}
		}
	}

	render() {
		return (
			<Auto
				{...this.props}
				menuWidth="400px"
				loader={this.sponsorsLoader}
				placeholder={this.props.placeholder} 
				maxLength={this.props.maxLength}
				/>
		)
	}
}

export default SponsorAuto;

// Mark this as a form component
SponsorAuto.defaultProps = {
	formControl: true,
	managed: false,
	placeholder: "Search..."
};



// WEBPACK FOOTER //
// ./src/areas/shared/controls/sponsorAuto/SponsorAuto.js